export const environment = {
  production: true,
  apiUrl: 'https://stageapi.loyverse.com',
  baseUrl: 'https://stage.loyverse.com/login/',
  siteUrl: 'https://stage.loyverse.com',
  backOfficeUrl: 'https://stager.loyverse.com',
  developerUrl: 'https://stagedeveloper.loyverse.com',
  assetsUrl: '/login/assets'
};
